module.exports = __webpack_public_path__ + "static/media/2.5226cee1.jpg";